/**
 * Module: Primo Piano Swiper Slider
 * Description: Inizializza uno slider Swiper per il blocco ACF Primo Piano.
 */

export function initPrimoPianoSlider() {
  if (typeof Swiper === "undefined") {
    console.warn("Swiper non disponibile per il blocco Primo Piano!");
    return;
  }

  const sliders = document.querySelectorAll(".swiper-primopiano");

  if (sliders.length === 0) {
    console.warn("Nessuno slider Primo Piano trovato nella pagina.");
    return;
  }

  sliders.forEach((slider, index) => {
    const wrapperId =
      slider.closest(".swiper-wrapper")?.id || `swiper-primopiano-${index}`;
    console.log(
      `Inizializzazione slider Primo Piano [${index + 1}] → ID: ${wrapperId} 👍`
    );

    const slides = slider.querySelectorAll(".swiper-slide");
    const enableLoop = slides.length > 1;

    new Swiper(slider, {
      spaceBetween: 0,
      loop: enableLoop,
      speed: 1000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true, // opzionale, per un fade più fluido
      },
      pagination: {
        el: ".swiper-pagination-pillola",
        clickable: true,
      },
    });
  });
}
